export default __webpack_public_path__ + "static/media/Verde.ea2c04f7.png";